var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.293945H513V342.287H0V0.293945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.293945H513V114.291H0V0.293945Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 228.289H513V342.286H0V228.289Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.76 215.899H286.24V190.62L274.344 196.568L256.5 178.726L238.656 196.568L226.76 190.62V215.899ZM192.731 186.159L195.499 194.68H204.457L197.209 199.945L199.978 208.464L192.731 203.198L185.483 208.464L188.251 199.945L181.004 194.68H189.961L192.731 186.159ZM201.313 156.421L204.082 164.94H213.039L205.792 170.205L208.561 178.726L201.313 173.459L194.065 178.726L196.834 170.205L189.587 164.94H198.544L201.313 156.421ZM225.849 134.117L228.618 142.635H237.575L230.328 147.901L233.096 156.421L225.849 151.155L218.601 156.421L221.37 147.901L214.122 142.635H223.08L225.849 134.117ZM320.269 186.159L317.501 194.68H308.544L315.791 199.945L313.022 208.464L320.269 203.198L327.518 208.464L324.749 199.945L331.996 194.68H323.039L320.269 186.159ZM311.687 156.421L308.918 164.94H299.961L307.208 170.205L304.44 178.726L311.687 173.459L318.935 178.726L316.166 170.205L323.413 164.94H314.456L311.687 156.421ZM287.151 134.117L284.382 142.635H275.425L282.672 147.901L279.904 156.421L287.151 151.155L294.399 156.421L291.631 147.901L298.878 142.635H289.92L287.151 134.117ZM256.5 122.963L259.268 131.483H268.227L260.979 136.749L263.747 145.267L256.5 140.003L249.253 145.267L252.021 136.749L244.773 131.483H253.732L256.5 122.963Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.290039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTj);
export default __webpack_public_path__ + "static/media/TJ.c0bc092864387692c2518f64817ff1ea.svg";
export { ForwardRef as ReactComponent };